import { render, staticRenderFns } from "./StepsOldFlow.vue?vue&type=template&id=830969f4&"
import script from "./StepsOldFlow.vue?vue&type=script&lang=js&"
export * from "./StepsOldFlow.vue?vue&type=script&lang=js&"
import style0 from "./StepsOldFlow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('830969f4')) {
      api.createRecord('830969f4', component.options)
    } else {
      api.reload('830969f4', component.options)
    }
    module.hot.accept("./StepsOldFlow.vue?vue&type=template&id=830969f4&", function () {
      api.rerender('830969f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/wizardFlow/wizard/flow/components/StepsOldFlow.vue"
export default component.exports